import { useMutation } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ManagementAddNewLoanValidateAddOld } from 'services/loans/manager'

export default function useSetFinalOld() {
    const navigate = useNavigate()
    const { state } = useLocation()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IIManagementAddOldPayload) => {
            return ManagementAddNewLoanValidateAddOld(payload)
        },
        onSuccess: (response, variables) => {
            toast.success('وام با موفقیت ثبت گردید')
            navigate(`/fund/${state?.payload?.moneyPool}`, {
                state: { poolShipId: state?.payload?.poolShip },
            })
        },
        onError: (error) => {
            toast.error('مشکلی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
